var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08425 14.1879L4.07314 14.1955L4.06246 14.2038C4.03286 14.2265 4.00939 14.2322 3.992 14.2333C3.97218 14.2346 3.94793 14.2302 3.92251 14.2167C3.87052 14.1891 3.83398 14.1359 3.83398 14.0667V1.9334C3.83398 1.86419 3.87052 1.81099 3.92251 1.7834C3.94793 1.76991 3.97218 1.76557 3.992 1.76681C4.00939 1.76789 4.03286 1.7736 4.06246 1.79637L4.07365 1.80498L4.08531 1.81294L12.9186 7.84628L12.9186 7.8463L12.9233 7.84942C12.9804 7.88751 13.0007 7.93767 13.0007 7.9834C13.0007 8.02913 12.9804 8.07928 12.9233 8.11737L12.9233 8.11733L12.9176 8.12124L4.08425 14.1879Z",
    fill: "#171719",
    stroke: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.004f94c4da1d12a731c874e9001805ae.svg";
export { ForwardRef as ReactComponent };